import React from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { useForm } from "react-hook-form";
import { useAddEmployeeCtc } from "../../../queries/employeeQueries";
import { toast } from "react-toastify";
import moment from "moment";
import { floatNumberRegex } from "../../../utils/regex/regex";
import { Tooltip } from "antd";
import { infoIcon } from "../../../Icons/Icons";

const EditOrAddEmployeeSalary = ({
  openModal,
  onCloseModal,
  employee,
  salaryData,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    defaultValues: {
      ctc: salaryData?.ctc || "",
      effective_date: salaryData?.effective_date
        ? moment(salaryData.effective_date, "DD-MM-YYYY").format("YYYY-MM-DD")
        : "",
    },
  });

  const addEmployeeCtc = useAddEmployeeCtc();

  const onSubmit = async (formData) => {
    try {
      const payload = {
        employee_id: employee?.employee_id,
        ctc: formData.ctc,
        effective_date: moment(formData.effective_date, "YYYY-MM-DD").format(
          "YYYY-MM-DD"
        ),
      };

      const response = await addEmployeeCtc.mutateAsync(payload);

      toast.success(
        response?.message || "Employee salary updated successfully!"
      );
      onCloseModal();
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to update salary");
    }
  };

  return (
    openModal && (
      <Modal open={openModal} onClose={onCloseModal} center>
        <div className="p-5 w-[520px]">
          <h2 className="text-lg leading-6 text-[#1F2937] font-semibold mb-5">
            {salaryData ? "Edit Salary" : "Add Salary"}
          </h2>

          <form
            className="flex flex-col gap-4 justify-center"
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className="w-[456px]">
              <label className="text-sm font-medium text-black">
                Annual CTC <span className="text-red-700">*</span>
              </label>
              <input
                type="text"
                className="h-[38px]"
                {...register("ctc", {
                  required: "CTC is required",
                  pattern: {
                    value: floatNumberRegex,
                    message:
                      "Value must be a valid number with up to 10 digits and 2 decimal places",
                  },
                  validate: (value) =>
                    parseFloat(value) > 0 || "CTC must be greater than 0",
                })}
              />
              {errors.ctc && (
                <span className="text-red-500 text-xs">
                  {errors.ctc.message}
                </span>
              )}
            </div>

            <div className="w-[456px]">
              <div className="text-sm font-medium text-black flex items-center gap-1">
                Effective Date <span className="text-red-700">*</span>
               <Tooltip title="This date determines when the updated or newly created salary will become effective.">
  <span className="cursor-pointer">{infoIcon}</span>
</Tooltip>
              </div>

              <input
                type="date"
                className="h-[38px]"
                {...register("effective_date", {
                  required: "Effective date is required",
                })}
              />

              {errors.effective_date && (
                <span className="text-red-500 text-xs">
                  {errors.effective_date.message}
                </span>
              )}
            </div>

            <div className="flex justify-end gap-3 mr-5">
              <button
                type="button"
                className="btn btn--border text-sm font-medium"
                onClick={onCloseModal}
              >
                Cancel
              </button>
              <button type="submit" className="btn text-sm font-medium">
                Save Changes
              </button>
            </div>
          </form>
        </div>
      </Modal>
    )
  );
};

export default EditOrAddEmployeeSalary;
